import _ from 'lodash';
import React, {useContext, ReactNode} from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import ModalContext from '../../context/ModalContext';
import TooltipWrapper from '../TooltipWrapper/TooltipWrapper';
import { TOOLTIP_SECTIONS } from '../../enums';
import { SDialog } from '@avalara/skylab-sdk/react';

interface Props {
  title: string;
  body: ReactNode;
  footer: ReactNode;
  isOpen: boolean;
  className?: string;
  innerModal?: boolean;
  onClose?: () => void;
  tooltipText?: string;
}

const compare = (prev: Props, next: Props) => {
  return _.isEqual(prev, next) ? true : false;
};

const Modal = React.memo(function Modal(props: Props) {
  const { title, body, footer, isOpen, className, onClose, tooltipText, innerModal=false } = props;
  const { dispatch } = useContext(ModalContext);

  return (
    <>
      <SDialog
        open={isOpen}
        className={classNames(className, styles.container)}
        onS-dismiss={() => {
          dispatch({ type: "CLOSE" });
          onClose?.();
        }}
        noDismiss={false}
      >
        <div
          slot='header'
          className={classNames(styles.header, 'modal-header')}
        >
          <TooltipWrapper
            tooltipSection={TOOLTIP_SECTIONS.Modal}
            tooltipKey={tooltipText ? tooltipText : title}
          >
            <span>{title}</span>
          </TooltipWrapper>
        </div>
        <div slot='body' className={classNames('modal-body')}>
          {body}
        </div>
        <div
          slot='footer'
          className={classNames(styles.footer, 'modal-footer')}
        >
          {footer}
        </div>
      </SDialog>
      {isOpen && <div className={classNames(styles.backdrop, innerModal && styles.innerModal)}></div>}
    </>
  );
}, compare);

export default Modal;
